import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { SeatingArea } from '../models/SeatingArea'
import { SEATING_AREAS_URL } from '../utils/urls'

const fetchSeatingAreas = (params: TableParams) =>
  SBAPI.FetchPaginated<SeatingArea[]>(SEATING_AREAS_URL, params)

const fetchSeatingAreaById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<SeatingArea>(`${SEATING_AREAS_URL}/${id}`, params)

const createSeatingArea = (seatingArea: SeatingArea) =>
  SBAPI.Post(SEATING_AREAS_URL, seatingArea)

const updateSeatingArea = (seatingArea: SeatingArea) =>
  SBAPI.Put(`${SEATING_AREAS_URL}/${seatingArea.id}`, seatingArea)

const deleteSeatingArea = (seatingArea: SeatingArea) =>
  SBAPI.Delete(`${SEATING_AREAS_URL}/${seatingArea.id}`)

export {
  createSeatingArea,
  deleteSeatingArea,
  fetchSeatingAreaById,
  fetchSeatingAreas,
  updateSeatingArea,
}
